export default __webpack_public_path__ + "static/media/ImgCarbon.d0c13538.png";